export const BASE_URL = process.env.REACT_APP_BASE_URL; 
const ENV = process.env.REACT_APP_ENV; 
const baseUrl = {
  PROD: 'https://api.learnify.ing',
  UAT: 'https://magical-ai-api-stage.com',
  QA: 'https://magical-ai-api-stage.com',
  DEV: 'http://localhost:9001',
};

export const getBaseUrl = () => {
  return BASE_URL;
};
